import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 2,
    hours: 14,
    minutes: 23,
    seconds: 45
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { days, hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              } else {
                // Reset to maintain evergreen urgency
                days = 2;
                hours = 14;
                minutes = 23;
                seconds = 45;
              }
            }
          }
        }
        
        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="text-center">
      <p className="text-yellow-400 text-lg mb-4 font-semibold">
        Next Live Session Starts In:
      </p>
      <div className="flex justify-center space-x-4">
        {Object.entries(timeLeft).map(([unit, value]) => (
          <motion.div
            key={unit}
            initial={{ scale: 1 }}
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ duration: 1, repeat: Infinity, repeatDelay: 1 }}
            className="bg-gradient-to-b from-red-500 to-red-600 text-white p-4 rounded-lg min-w-[80px]"
          >
            <div className="text-2xl md:text-3xl font-bold">
              {value.toString().padStart(2, '0')}
            </div>
            <div className="text-sm capitalize opacity-90">{unit}</div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CountdownTimer;